{
  "version": 1,
  "asset_id": "517eaeb7-dea4-4793-93f5-207835cfbbb3",
  "project_id": "4dbb42ac-931e-41e9-ac57-3f509e458f26",
  "url": "/__l5e/assets-v1/517eaeb7-dea4-4793-93f5-207835cfbbb3/core-plus-placeholder.jpg",
  "r2_key": "a/v1/4dbb42ac-931e-41e9-ac57-3f509e458f26/517eaeb7-dea4-4793-93f5-207835cfbbb3/core-plus-placeholder.jpg",
  "original_filename": "core-plus-placeholder.jpg",
  "size": 392341,
  "content_type": "image/jpeg",
  "created_at": "2026-09-06T19:18:17Z"
}
